export const arrUnique = (arr: any[]): any[] =>
  arr.filter((value, index, self) => self.indexOf(value) === index);

export default arrUnique;
